import React from "react";
import { connect } from "react-redux";

import { getCookiebox } from "../../state/reducers/cookiebox";
import { iframeParse } from "../../utils/functions";

import Core from "./Core";
import Cgb from "./Cgb";

const switchBlocks = {
  core: Core,
  cgb: Cgb
};

const Blocks = ({ blockName, cookiebox, innerHTML, ...rest }) => {
  // Gestion des cas d'erreur
  if (!blockName || typeof blockName !== 'string') {
    return null;
  }

  const blockSplit = blockName.split("/")[0];
  const blockHTML = cookiebox ? iframeParse(innerHTML) : innerHTML;
  
  // Vérifier si le bloc est reconnu
  if (blockSplit && typeof switchBlocks[blockSplit] === "function") {
    return switchBlocks[blockSplit]({
      blockName,
      innerHTML: blockHTML,
      ...rest
    });
  }

  // Si le bloc n'est pas reconnu, retourner le HTML parsé
  return (
    <div 
      role="region" 
      aria-label="Contenu dynamique"
      dangerouslySetInnerHTML={{ __html: blockHTML || '' }}
    />
  );
};

const mapStateToProps = state => ({
  cookiebox: getCookiebox(state)
});

export default connect(mapStateToProps)(Blocks);
